import { analyzePrompt, type CreatePromptMessageRequest } from '../api';
import { useAbortableMutation } from '@/shared/hooks/use-abortable-mutation';
import { searchCreatorPendingAtom } from '@/features/discovery/stores/mutation-atom';

type AnalyzeDiscoveryPromptMutationRequest = {
  discoverySessionId: string;
  request: CreatePromptMessageRequest;
};

export function useAnalyzeDiscoveryPrompt() {
  return useAbortableMutation({
    mutationFn: (req: AnalyzeDiscoveryPromptMutationRequest, signal) =>
      analyzePrompt(req.discoverySessionId, req.request, signal),
    pendingAtom: searchCreatorPendingAtom,
    requestKey: 'discovery:analyze-discovery',
  });
}
